<div class="container py-3">
	<div class="row text-center">
		<h1>{{ "iterlex.login-failed" | translate }}</h1>
	</div>
</div>
